<template>
    <div>
        <div class="vx-row">
            <div class="vx-col w-full">
                <vx-card id="clientDiv"  class="vs-con-loading__container">
                    <div class="vx-row">
                        <div class="vx-col xl:w-1/3 w-full">
                            <table class="simple-table mt-6" v-if="!editEnabled">
                              <tr>
                                <td class="font-semibold">Name:</td>
                                <td>{{ client.name }}</td>
                              </tr>
                                <tr>
                                    <td class="font-semibold">Username:</td>
                                    <td>{{ client.username }}</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Email:</td>
                                    <td>{{ client.email }}</td>
                                </tr>
                                <tr v-if="client.reseller_username.length > 0">
                                    <td class="font-semibold">Reseller:</td>
                                    <td>{{ client.reseller_username }}</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Credits:</td>
                                    <td>{{ client.credits }}</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Connections:</td>
                                    <td>{{ client.connections }}</td>
                                </tr>
                              <tr>
                                <td class="font-semibold">STB Pin:</td>
                                <td>{{ client.stb_access_pin_formatted }}</td>
                              </tr>
                                <tr>
                                    <td class="font-semibold">Status:</td>
                                    <td>
                                        <vs-chip color="danger" v-if="!client.enabled">Disabled</vs-chip>
                                        <vs-chip color="success" v-else>Enabled</vs-chip>
                                    </td>
                                </tr>
                            </table>
                            <div v-else>
                              <p class="mt-6">Name</p>
                              <vs-input v-model="editObject['name']" class="w-full"></vs-input>
                                <p class="mt-6">Email</p>
                                <vs-input v-model="editObject['email']" class="w-full"></vs-input>
                            </div>
                        </div>
                        <div class="vx-col xl:w-2/3 w-full">
                            <credit-changes-table ref="creditChangesTable" :client-id="Number($route.params.id)"/>
                        </div>
                    </div>
                    <vs-divider/>
                    <vs-button style="float: left" icon-pack="feather" icon="icon-edit" v-if="!editEnabled" color="warning" class="mt-6; mr-1" @click="editEnabled = true">Edit</vs-button>
                    <vs-button style="float: left" icon-pack="feather" icon="icon-square" v-if="client.enabled && !editEnabled" color="danger" class="mt-6; mr-1" @click="disableUser">Disable user</vs-button>
                    <vs-button style="float: left" icon-pack="feather" icon="icon-play" v-if="!client.enabled && !editEnabled" color="success" class="mt-6; mr-1" @click="enableUser">Enable user</vs-button>
                    <vs-button style="float: left" icon-pack="feather" icon="icon-file-text" v-if="!editEnabled" color="primary" class="mt-6; mr-1" @click="playlistPromptOpen = true">Playlist</vs-button>
                    <vs-button style="float: left" icon-pack="feather" icon="icon-list" v-if="!editEnabled" color="primary" class="mt-6; mr-1" @click="copyEPGHTTPS">Copy HTTPS EPG</vs-button>
                    <vs-button style="float: left" icon-pack="feather" icon="icon-list" v-if="!editEnabled" color="primary" class="mt-6; mr-1" @click="copyEPGHTTP">Copy HTTP EPG</vs-button>
                    <vs-button style="float: right" icon-pack="feather" icon="icon-dollar-sign" v-if="!editEnabled" color="success" class="mt-6; mr-1" @click="addCreditsPrompt = true" disabled>Add credits</vs-button>
                    <vs-button style="float: left" icon-pack="feather" icon="icon-save" v-if="editEnabled" color="success" class="mt-6; mr-1" @click="saveClient">Save</vs-button>
                    <vs-button style="float: left" icon-pack="feather" icon="icon-x" v-if="editEnabled" color="warning" class="mt-6; mr-1" @click="editEnabled = false">Cancel</vs-button>
                    <vs-button style="float: right" icon-pack="feather" icon="icon-trash-2" v-if="editEnabled" color="danger" class="mt-6; mr-1" @click="removeClient">Remove</vs-button>
                    <div style="clear: both"></div>
                </vx-card>
            </div>

            <div class="vx-col w-full mt-6">
                <client-connections :client-id="Number($route.params.id)"/>
            </div>

            <div class="vx-col w-full mt-6">
                <available-packages-table ref="packagesTable" :client-id="Number($route.params.id)" v-on:activation="$refs.activationsTable.loadData()"/>
            </div>

            <div class="vx-col w-full mt-6">
                <package-activations ref="activationsTable" :client-id="Number($route.params.id)" v-on:disable="$refs.packagesTable.loadData()"/>
            </div>

        </div>

        <vs-popup title="Add credits" :active.sync="addCreditsPrompt">
            <div id="addCreditsDiv" class="vs-con-loading__container" >
                <p class="mt-6">Credits</p>
                <vs-input v-model="addCreditsNum" class="w-full"></vs-input>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addCredits">Add</vs-button>
            </div>
        </vs-popup>

        <vs-popup title="Copy playlist" :active.sync="playlistPromptOpen">
            <div>
                <vs-checkbox class="mt-3" v-model="playlistHTTPS">HTTPS Playlist</vs-checkbox>
                <p class="mt-6">Playlist type</p>
                <vs-select autocomplete class="w-full" v-model="playlistType">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in playlistTypes" />
                </vs-select>
                <vs-divider/>
                <h6 class="mt-6">Link</h6>
                <p>{{playlistURL}}</p>
                <vs-divider/>
                <vs-button color="success" icon-pack="feather" icon="icon-clipboard" class="mt-6; mr-1" @click="copyPlaylist">Copy</vs-button>
            </div>
        </vs-popup>

    </div>
</template>
<script>

    import CreditChangesTable from "./CreditChangesTable";
    import AvailablePackagesTable from "./AvailablePackagesTable";
    import PackageActivations from "./PackageActivations";
    import ClientConnections from "./ClientConnections";
    import store from "../../store/store";

    export default {
        components: {
            ClientConnections,
            PackageActivations,
            AvailablePackagesTable,
            CreditChangesTable,
        },
        data(){
            return{

                client: {

                    username: "",
                    email: "",
                    reseller_username: "",
                    credits: 0
                },

                editObject: {},
                editEnabled: false,

                addCreditsPrompt: false,
                addCreditsNum: 0,

                playlistPromptOpen: false,
                playlistHTTPS: true,
                playlistType: 0,

              playlistTypes: [
                {
                  id: 0,
                  name: 'M3U8'
                },
                {
                  id: 6,
                  name: 'JSON'
                },
                {
                  id: 5,
                  name: 'VOD M3U8'
                },
                {
                  id: 7,
                  name: 'JSON VOD'
                },
                {
                  id: 1,
                  name: 'Enigma'
                },
                {
                  id: 2,
                  name: 'Enigma 16'
                },
                {
                  id: 3,
                  name: 'Enigma script'
                },
                {
                  id: 4,
                  name: 'Enigma 16 script'
                }
              ]

            }
        },
        methods: {
            loadData(){

                this.$vs.loading({
                    container: "#clientDiv",
                    type: 'corners',
                    scale: 0.7
                });

                const thisIns = this;
                const loadPromise = this.$http.get('/api/reseller/v1/client/' + this.$route.params.id);
                loadPromise.then(function (response) {
                    thisIns.client = response.data;
                    thisIns.editObject = JSON.parse(JSON.stringify(response.data));
                }).catch(function (error) {
                    thisIns.$printError(error.response.data);
                }).finally(function () {
                    thisIns.$vs.loading.close("#clientDiv > .con-vs-loading");
                });

            },
            saveClient(){

                this.$vs.loading({
                    container: "#clientDiv",
                    type: 'corners',
                    scale: 0.7
                });

                const thisIns = this;
                const savePromise = this.$http.put('/api/reseller/v1/client/' + this.$route.params.id, {
                    name: this.editObject.name,
                    email: this.editObject.email,
                });

                savePromise.then(function () {
                    thisIns.$printSuccess("User saved");
                    thisIns.editEnabled = false;
                    thisIns.loadData();
                }).catch(function (error) {
                    thisIns.$printError(error.response.data);
                }).finally(function () {
                    thisIns.$vs.loading.close("#clientDiv > .con-vs-loading");
                })
            },
            disableUser(){

                this.$vs.loading({
                    container: "#clientDiv",
                    type: 'corners',
                    scale: 0.7
                });

                const thisIns = this;
                const disablePromise = this.$http.put('/api/reseller/v1/client/' + this.$route.params.id + '/disable');
                disablePromise.then(function () {
                    thisIns.$printSuccess("User disabled");
                    thisIns.loadData();
                }).catch(function (error) {
                    thisIns.$printError(error.response.data);
                }).finally(function () {
                    thisIns.$vs.loading.close("#clientDiv > .con-vs-loading");
                })
            },
            enableUser(){

                this.$vs.loading({
                    container: "#clientDiv",
                    type: 'corners',
                    scale: 0.7
                });

                const thisIns = this;
                const disablePromise = this.$http.put('/api/reseller/v1/client/' + this.$route.params.id + '/enable');
                disablePromise.then(function () {
                    thisIns.$printSuccess("User enabled");
                    thisIns.loadData();
                }).catch(function (error) {
                    thisIns.$printError(error.response.data);
                }).finally(function () {
                    thisIns.$vs.loading.close("#clientDiv > .con-vs-loading");
                })
            },
            removeClient(){

                const thisIns = this;
                const removePromise = this.$http.delete('/api/reseller/v1/client/' + this.$route.params.id);
                removePromise.then(function () {
                    thisIns.$printSuccess("Client removed");
                    thisIns.$nextTick(() => {
                        thisIns.$router.push("/clients");
                    });
                }).catch(function (error) {
                    thisIns.$printError(error.response.data);
                })
            },
            addCredits(){

                this.$vs.loading({
                    container: "#addCreditsDiv",
                    type: 'corners',
                    scale: 0.7
                });

                const thisIns = this;
                const savePromise = this.$http.put('/api/reseller/v1/client/' + this.$route.params.id + "/credits", {
                    credits: Number(this.addCreditsNum),
                });

                savePromise.then(function () {
                    thisIns.$printSuccess("Credits added");
                    thisIns.addCreditsPrompt = false;
                    thisIns.addCreditsNum = ""
                    thisIns.loadData();
                    thisIns.$refs.creditChangesTable.loadData();
                    thisIns.$store.dispatch('setCredits');
                }).catch(function (error) {
                    thisIns.$printError(error.response.data);
                }).finally(function () {
                    thisIns.$vs.loading.close("#addCreditsDiv > .con-vs-loading");
                })
            },
            copyPlaylist(){
                const thisIns = this;
                thisIns.$copyText(thisIns.playlistURL).then(function() {
                    thisIns.$printSuccess("Link copied to clipboard");
                }, function() {
                    thisIns.$printError("Cannot copy link to clipboard");
                })
            },
            copyEPGHTTPS(){
                const thisIns = this;
                thisIns.$copyText(thisIns.client.epg_url).then(function() {
                    thisIns.$printSuccess("Link copied to clipboard");
                }, function() {
                    alert(thisIns.client.epg_url);
                })
            },
            copyEPGHTTP(){
                const thisIns = this;
                thisIns.$copyText(thisIns.client.epg_url_http).then(function() {
                    thisIns.$printSuccess("Link copied to clipboard");
                }, function() {
                    alert(thisIns.client.epg_url_http);
                })
            }
        },
        computed: {
          playlistURL() {
            const baseURL = (this.playlistHTTPS) ? this.client.playlist_url : this.client.playlist_url_http
            let playlistTypeBase
            switch (this.playlistType) {
              case 0:
                playlistTypeBase = 'm3u8'
                break
              case 1:
                playlistTypeBase = 'enigma'
                break
              case 2:
                playlistTypeBase = 'enigma16'
                break
              case 3:
                playlistTypeBase = 'enigma_script'
                break
              case 4:
                playlistTypeBase = 'enigma16_script'
                break
              case 5:
                playlistTypeBase = 'm3u8_vod'
                break
              case 6:
                playlistTypeBase = 'json'
                break
              case 7:
                playlistTypeBase = 'json_vod'
                break
            }

            const finalPlaylistType = playlistTypeBase + '_' + ((this.playlistHTTPS) ? 'https' : 'http')

            return baseURL + '?playlist_type=' + finalPlaylistType
          }
        },
        mounted() {
            this.loadData();
        }

    }

</script>
<style lang="scss" scoped>
    .simple-table {
        td {
            vertical-align: top;
            min-width: 250px;
            padding-bottom: 1.3rem;
            word-break: break-all;

            @media screen and (max-width:370px) {
                display: block;
            }
        }
    }

</style>
